import { Component, OnInit, ViewEncapsulation, ViewChild, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';


@Component({
    selector:    'master1-text',
    templateUrl: './master1-text-dialog.html',
    styleUrls:  ['./master1-text-dialog.scss'],
  })
  export class Master1TextDialog {
  
    constructor(
      public dialogMaster1Text: MatDialogRef<Master1TextDialog>,
      @Inject( MAT_DIALOG_DATA ) public data: any) { }
  
    onNoClick(): void {
      this.dialogMaster1Text.close();
    }
  
  }